import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'
import Tooltip from '../../../Shared/Tooltip'

import ProductAnalyticsTable from './ProductAnalyticsTable'
import ProductAnalyticsTiersContainer from './Tiers/ProductAnalyticsTiersContainer'

function ProductAnalyticsTopKeywords({
  keywords,
  searchKeyword,
  dataFetch,
  moreButtonToggle,
  showMoreKeywords,
  scopeButtonClassName,
  handleGroupChange,
  tiersData,
  tierRule,
  tabSwitch,
}) {
  const group = ['categories', 'subcategories', 'model_tags', 'deficit_keywords']
  const topKeywordsTableClass = keywords.hidden ? 'is-search-enabled' : 'is-search-enabled is-expanded'
  const ruleInfo = tiersData.meta.tiers.find(info => info.rule === tierRule)

  function ShowTable() {
    return (
      keywords.data.length > 0 ? (
        <div>
          <ProductAnalyticsTable
            type={topKeywordsTableClass}
            keywords={keywords}
            searchTerm=""
            searchKeyword={searchKeyword}
            fetch={dataFetch}
            tiersData={tiersData}
            scope="top"
          />

          {keywords.data.length > keywords.show
          && (
          <button
            className="btn btn-transparent btn-block btn-show-more"
            onClick={showMoreKeywords}
          >{moreButtonToggle ? 'show more' : 'show less'}
          </button>
          )
          }
        </div>
      ) : (
        <div className="empty-content u-text-center">
          <p>
            Sorry, no keywords found. Try changing group
          </p>
        </div>
      )
    )
  }

  return (
    <div>
      <h2 className="content-heading__h2">
        Top Keywords
        <Tooltip
          tooltipClassName="tooltip--big tooltip--spaced"
          id="top-keywords--tooltip"
          content="Each report is compiled of top 100 keywords sorted by Score to show which topics have the most
           demand and lowest competition. Use filters on the right to analyze Categories, Subcategories or more specific
           tags."
        >
          <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
        </Tooltip>
        <div className="content-heading__buttons">
          <div className="btn-group">
            <button
              className={scopeButtonClassName(group[0])}
              onClick={() => (handleGroupChange(group[0], 2))}
            >
              <Tooltip
                tooltipClassName="tooltip--medium tooltip--spaced"
                id="tabs-categories--tooltip"
                content="Most popular Top Keywords, usually generic keywords or broad categories."
              >
                Categories
              </Tooltip>
            </button>
            <button
              className={scopeButtonClassName(group[1])}
              onClick={() => (handleGroupChange(group[1], 3))}
            >
              <Tooltip
                tooltipClassName="tooltip--medium tooltip--spaced"
                id="tabs-subcategories--tooltip"
                content="Medium popularity Top Keywords, shows less common or more defined keywords."
              >
                Subcategories
              </Tooltip>
            </button>
            <button
              className={scopeButtonClassName(group[2])}
              onClick={() => (handleGroupChange(group[2], 4))}
            >
              <Tooltip
                tooltipClassName="tooltip--medium tooltip--spaced"
                id="tabs-tags--tooltip"
                content="Narrow Top Keywords, represents rare keywords or specific objects."
              >
                Model Tags
              </Tooltip>
            </button>
          </div>
          <button
            className={scopeButtonClassName(group[3])}
            onClick={() => (handleGroupChange(group[3], 6))}
          >
            <Tooltip
              tooltipClassName="tooltip--medium tooltip--spaced"
              id="tabs-deficit--tooltip"
              content="This analysis shows most searched keywords with none or very few models. It shows gaps in
            supply and niche models in demand."
            >
              Deficit Keywords
            </Tooltip>
          </button>
        </div>
      </h2>
      {tiersData.data.user.currentTier >= ruleInfo.requiredUserLevel ? (
        <ShowTable />
      ) : (
        tierRule === 2 ? (
          <div>
            <ShowTable />
            <ProductAnalyticsTiersContainer tiersData={tiersData} tierRule={tierRule} tabSwitch={tabSwitch} hr />
          </div>
        ) : (
          <ProductAnalyticsTiersContainer tiersData={tiersData} tierRule={tierRule} tabSwitch={tabSwitch} hr />
        )
      )}
    </div>
  )
}

ProductAnalyticsTopKeywords.propTypes = {
  keywords: PropTypes.object.isRequired,
  searchKeyword: PropTypes.func.isRequired,
  dataFetch: PropTypes.func.isRequired,
  moreButtonToggle: PropTypes.bool.isRequired,
  showMoreKeywords: PropTypes.func.isRequired,
  scopeButtonClassName: PropTypes.func.isRequired,
  handleGroupChange: PropTypes.func.isRequired,
  tiersData: PropTypes.object.isRequired,
  tierRule: PropTypes.number.isRequired,
  tabSwitch: PropTypes.func.isRequired,
}

export default ProductAnalyticsTopKeywords
